import React from 'react'

import { Radio } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import { ItemContent } from './RecipeOptionsItemContent'

import css from './RecipeOptionsItem.css'

type RecipeOptionsItemProps = {
  recipeId: string
  recipeName: string
  changeCheckedRecipe: () => void
  isChecked: boolean
  isOutOfStock: boolean
  surcharge?: number | null
  surchargeLabel?: string | null
}

export const RecipeOptionsItem = ({
  recipeId,
  recipeName,
  changeCheckedRecipe,
  isChecked,
  isOutOfStock,
  surcharge = null,
  surchargeLabel = null,
}: RecipeOptionsItemProps) => (
  <li className={classnames(css.listItem, { [css.listItemChecked]: isChecked })}>
    <Radio
      id={recipeId}
      value={recipeId}
      name="variantList"
      onChange={changeCheckedRecipe}
      checked={isChecked}
      style={{ width: '100%' }}
    >
      {() => (
        <ItemContent
          recipeName={recipeName}
          isOutOfStock={isOutOfStock}
          surcharge={surcharge}
          surchargeLabel={surchargeLabel}
          isChecked={isChecked}
        />
      )}
    </Radio>
  </li>
)
